/**
 * ReportPhaseWrapper
 * Thin layout wrapper for report-phase routes inside AssessmentShell.
 * Renders DimensionNav sidebar alongside an Outlet for report pages.
 * AssessmentShell handles breadcrumb, PhaseBar, and ReportProvider.
 */

import { Outlet, useParams } from 'react-router-dom';
import { DimensionNav } from '@/components/layout/DimensionNav';

/**
 * Wrapper that provides DimensionNav sidebar for report-phase routes.
 * Rendered as a child of AssessmentShell's flex container.
 *
 * @returns Fragment containing DimensionNav sidebar and scrollable content Outlet
 */
export function ReportPhaseWrapper(): JSX.Element {
  const { id: assessmentId } = useParams<{ id: string }>();

  if (!assessmentId) {
    return <div className="p-8 text-center text-destructive">Missing assessment ID.</div>;
  }

  const basePath = `/assessments/${assessmentId}/analysis`;

  return (
    <>
      <DimensionNav basePath={basePath} />
      <div className="flex-1 overflow-y-auto px-6 lg:px-8 py-6 lg:py-8">
        <div className="max-w-5xl mx-auto">
          <Outlet />
        </div>
      </div>
    </>
  );
}
